export default "__VITE_PUBLIC_ASSET__5d67386c__"